import React, {useState} from 'react';
import {Loader} from '../../components/Loader';
import WorkspacePreviews from "./WorkspacesPreview";
import {useUserContext} from "../../contexts/user_context";
import DashboardHeader from "../../components/DashboardHeader";
import DemoSeedingBanner from "./DemoSeedingBanner";


interface PrimaryDashboardPageProps {
}


const PrimaryDashboardPage: React.FC<PrimaryDashboardPageProps> = () => {
    const {
        currentUser,
    } = useUserContext()!;

    const [loading] = useState(false);


    return (
        <DashboardHeader>
            {/* Loader overlay */}
            {loading && (
                <div
                    className="absolute top-0 left-0 right-0 bottom-0 flex justify-center items-center z-50"
                    style={{backgroundColor: 'rgba(255, 255, 255, 0.7)'}}>
                    <Loader/>
                </div>
            )}

            <div className="flex flex-1 flex-col h-full">
                {/* Nav/header area */}
                <div className="flex flex-row items-center p-4">
                    <span className="text-2xl font-semibold text-[#15151b]">
                      Hello, {currentUser?.first_name} ({currentUser?.email})
                    </span>
                </div>

                {/* Content area */}
                <div className="flex-1 overflow-auto">
                    <DemoSeedingBanner/>
                    <WorkspacePreviews/>
                </div>
            </div>
        </DashboardHeader>
    );
}
export default PrimaryDashboardPage;
